import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'currency-groups-h',
  templateUrl: './currency-groups-h.component.html',
  styleUrls: ['./currency-groups-h.component.css'],
})

export class CurrencyGroupsHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Currency Group Event Log");

    $(document).ready(function() {
    			// prepare the data
    			var data = [ {
    				"timestamp" : "5/5/2015 06:08:46.689",
    				"user" : "System",
    				"ipAddress" : "12.56.8.32",
    				"ccyGroup" : "Majors",
    				"ccys" : "CHF, EUR, GBP, JPY, USD"
    			}, {
    				"timestamp" : "5/5/2015 06:08:47.577",
    				"user" : "System",
    				"ipAddress" : "12.56.8.32",
    				"ccyGroup" : "Minors",
    				"ccys" : "AUD, CAD, DKK, NOK, NZD, SEK"
    			}, {
    				"timestamp" : "5/5/2015 06:08:47.989",
    				"user" : "System",
    				"ipAddress" : "12.56.8.32",
    				"ccyGroup" : "Exotics",
    				"ccys" : "HKD, INR, KRW, MXN, RUB, SGD, ZAR"
    			} ];

    			// initialize jqxGrid
    			var source = {
    				localdata : data,
    				datafields : [ {
    					name : 'timestamp',
    					type : 'string'
    				}, {
    					name : 'user',
    					type : 'string'
    				}, {
    					name : 'ipAddress',
    					type : 'string'
    				}, {
    					name : 'ccyGroup',
    					type : 'string'
    				}, {
    					name : 'ccys',
    					type : 'string'
    				} ]
    			};
    			var settings = defaultGridViewSettings("#jqxgrid", source);
    			settings.columns = [ {
    				text : 'Timestamp',
    				columntype : 'textbox',
    				datafield : 'timestamp',
    				width : '160'
    			}, {
    				text : 'User',
    				columntype : 'textbox',
    				datafield : 'user',
    				width : '100'
    			}, {
    				text : 'IP Address',
    				columntype : 'textbox',
    				datafield : 'ipAddress',
    				width : '80'
    			}, {
    				text : 'Ccy Group',
    				columntype : 'textbox',
    				datafield : 'ccyGroup',
    				width : '80'
    			}, {
    				text : 'Currencies',
    				columntype : 'textbox',
    				datafield : 'ccys',
    				width : '300'
    			} ];
    			$("#jqxgrid").jqxGrid(settings);
    		});
    	/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/currency-groups-h/currency-groups-h.component.ts